import { RoleInRelationshipOptionsType } from './types';

export const ROLE_IN_RELATIONSHIP_OPTIONS: RoleInRelationshipOptionsType = [
  { id: 'leader', title: 'The leader / dominant' },
  { id: 'supporter', title: 'The supporter / submissive' },
  { id: 'equal', title: 'Equal partners' },
  { id: 'switch', title: 'Switch / flexible' },
];
